import { useSelectedCoreLocationId, useSelectedLocation } from '@elva/platform';

/** core-api-az numeric location id — injected on marketing-api requests as `location_id`. */
export function useLocationId(): number | undefined {
  return useSelectedCoreLocationId();
}

/** Account-service location UUID — session scoping and location switch. */
export function useLocationUuid(): string | undefined {
  return useSelectedLocation()?.id;
}
